import styled from "styled-components";

const ViewLink = styled.h3.attrs({ className: "text-uppercase" })`
  color: ${({ theme }) => theme.colors.link()};
  margin: 1rem 0;
`;

export default ViewLink;
